import styled from "styled-components";
import { ReactComponent as MapMarkerAlt } from "src/assets/icons/map-marker-alt.svg";

interface Props {
  color?: string;
}

export const MapMarkerIcon = styled(MapMarkerAlt).attrs((props: Props) => ({
  color: props.color || "#3fabff",
}))`
  .a {
    fill: ${({ color }) => color};
  }
`;
